import { render } from "./CookiePolicy.vue?vue&type=template&id=f786a8c2&ts=true"
import script from "./CookiePolicy.vue?vue&type=script&lang=ts"
export * from "./CookiePolicy.vue?vue&type=script&lang=ts"

import "./CookiePolicy.vue?vue&type=style&index=0&id=f786a8c2&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__